// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__iz1dH","label":"LabeledBox_label__3NcJh"};